import { render, staticRenderFns } from "./TableEstruturaRateio.vue?vue&type=template&id=7f6d1615&scoped=true&"
import script from "./TableEstruturaRateio.vue?vue&type=script&lang=js&"
export * from "./TableEstruturaRateio.vue?vue&type=script&lang=js&"
import style0 from "./TableEstruturaRateio.vue?vue&type=style&index=0&id=7f6d1615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d1615",
  null
  
)

export default component.exports